import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Errorbar} from '../../../global/errorbar';
import withRouter from 'react-router-dom/withRouter';
import { Auth } from '../../../../actions/Auth';
import Aux from '../../../global/AuxComp';
import { getFiles } from '../../../../actions';
import { setUser, setLoading } from '../../../../actions/action-creators';
import {Row,Col,Container } from 'reactstrap';
import {HorizontalLine} from '../../../global/horizontal_line';
import PTTeamNav from '../PTTeamNav';
import PostCard from './PostCard';
import CreatePost from './CreatePost';
import HelpSection from '../../helpSection/student_section';

const PAGE_SIZE = 20;

 class Feed extends Component{
  constructor(props){
    super(props);
    this.state = {
      getProcesList:  [],
      getStudentAssigned: [],
      modalstudent: false,
      modalshare:false,
      modal: false,
      modaledit: false,
      collapse: false,
      fileId: null,
      bannerId: null,
      videoId: null,
      popoverOpen: false,
      postsdata: [],
      files: {},
      file: null,
      post_tag: null,
      errorbar: false,
      message:'',
      title:'',
      content:'',
      popoverOpen2: false,
      process:{process_name: "Feed",process_type: "feed",process_id: 3},
      currentOffset: 0,
      hasMore: true,
      loadingMore: false,
    };
  }



  closebar = () =>{
      this.setState({errorbar: false});
  }



  componentWillMount() {
    this.init();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 300) {
      this.fetchPosts(this.state.currentOffset, false);
    }
  }

  init = () => {
    this.fetchPosts(0, true);
  }

  fetchPosts = async (offset, reset) => {
    const { hasMore, loadingMore } = this.state;
    if (!reset && (!hasMore || loadingMore)) return;
    if (reset) this.props.setLoading(true);
    else this.setState({ loadingMore: true });
    try {
      let posts = await Auth.Feed.postView({ limit: PAGE_SIZE, offset });
      let postsdata = posts.data;
      var fileIds = postsdata.map(p => p.file_id);
      let files = await getFiles(fileIds);
      postsdata = await this.appendCompanyRecruiterFeed(postsdata);
      this.setState(prev => ({
        postsdata: reset ? postsdata : [...prev.postsdata, ...postsdata],
        files: reset ? files : { ...prev.files, ...files },
        currentOffset: reset ? postsdata.length : prev.currentOffset + postsdata.length,
        hasMore: postsdata.length === PAGE_SIZE,
      }));
    } catch (e) {
      this.setState({errorbar: true, message: e && e.response && e.response.data ? e.response.data.error.toString() : "Something went wrong"});
    }
    if (reset) this.props.setLoading(false);
    else this.setState({ loadingMore: false });
  }

    appendCompanyRecruiterFeed = async (posts) => {
      var recruiterId = posts.filter(post => post.origin_type === "RECRUITER").map(post => post.origin_id);
      if(recruiterId.length === 0) return posts;
      recruiterId = [...new Set(recruiterId)];
      let recruiterResp = await Auth.Recruiter.Company.getCompany({recruiter_id : recruiterId});
      var recruiterDetail = recruiterResp.data.data.reduce((prev, curr) => {prev[curr.recruiter_id] = curr; return prev;}, {});
      console.log(recruiterDetail)
      posts = posts.map(post => {
        if(post.origin_type === "RECRUITER"){
          post.company_name = recruiterDetail[post.origin_id] ? recruiterDetail[post.origin_id].company_name : "Recruiter Not Found";
        }
        return post;
      })
      return posts;
    }

   toggle = () => {
    this.setState(state => ({ collapse: !state.collapse }));
  }


  likePost = async(data) =>{
        const {postsdata} = this.state;
          var stBody = {
                        "post_id":data.post_id,
                        "liked": (data.is_liked === 1)?"0":1
                        }
            try {
                  await Auth.Feed.createActivity(stBody);
                    let objIndex = postsdata.findIndex((obj => obj.post_id == data.post_id));
                    postsdata[objIndex].no_of_like = (data.is_liked === 1)?(data.no_of_like - 1):(data.no_of_like + 1) ;
                    postsdata[objIndex].is_liked = (data.is_liked === 1)?0:1
                    this.setState({postsdata});
                } catch (e) {
                  console.log(e.response)
                }
  }




  render(){
      return (
        <Aux>
          {/*<Row className="justify-content-between align-items-center">
            <Col xs="12">
              <PTTeamNav process={this.state.process}/>
            </Col>
          </Row>*/}
        {/* <HorizontalLine color ="#cfcfcf"/> */}
          <CreatePost refresh={this.init} handlepostToggle={this.handlepostToggle}/>
      { /* <Row  className="justify-content-between align-items-center my-5">
                     <Col xs="auto" >
                       <InputField className="r-nav__search" placeholder="Search" type="text" />
                       <span className="fi flaticon-search"></span>
                      </Col>
                      <Col xs="auto">
                          <Row>
                              <Col xs="auto">
                                  <select className="selectfield">
                                    <option value="volvo">Type</option>
                                    <option value="saab">Saab</option>
                                    <option value="opel">Opel</option>
                                    <option value="audi">Audi</option>
                                  </select>
                              </Col>
                              <Col xs="auto">
                                  <select className="selectfield">
                                    <option value="volvo">Time</option>
                                    <option value="saab">Saab</option>
                                    <option value="opel">Opel</option>
                                    <option value="audi">Audi</option>
                                  </select>
                              </Col>
                              <Col xs="auto">
                                  <select className="selectfield">
                                    <option value="volvo">Sector</option>
                                    <option value="saab">Saab</option>
                                    <option value="opel">Opel</option>
                                    <option value="audi">Audi</option>
                                  </select>
                              </Col>
                              <Col xs="auto">
                                  <select className="selectfield">
                                    <option value="volvo">Last Contacted</option>
                                    <option value="saab">Saab</option>
                                    <option value="opel">Opel</option>
                                    <option value="audi">Audi</option>
                                  </select>
                              </Col>
                          </Row>
                      </Col>
              </Row>*/}

        {this.state.postsdata.map((data,i) =>{
                  return(
                    <PostCard
                        key={i}
                        data={data}
                        files={this.state.files}
                        refreseh={this.init}
                        role_type={this.props.role.role_type}
                        redirect={this.props.history.push}
                        likePost={this.likePost}
                        init={this.init}
                    />
                  )
        })}
        {this.state.loadingMore && <div className="text-center py-3"><span>Loading...</span></div>}
        {!this.state.hasMore && this.state.postsdata.length > 0 && <div className="text-center py-3 r-subheading-4">No more posts</div>}
                    <Errorbar  showBar={this.state.errorbar} onClose={this.closebar} message={this.state.message}/>
      <HelpSection tab={"newsfeedTab"} />
      </Aux>
  )
 }
}

const mapStateToProps = state => ({
  ...state
})
const mapDispatchToProps = dispatch => ({
  setUser: (user) => dispatch(setUser(user)),
  setLoading: (show) => dispatch(setLoading(show)),
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Feed));
